import { useDefectRepairTypeV1ControllerGetByProject } from 'generated/apiComponents';
import { useSession } from 'technical/auth/client';

export const useGetDefectRepairTypeData = () => {
  const { data: session } = useSession();

  const { data, error, isLoading } =
    useDefectRepairTypeV1ControllerGetByProject(
      {
        queryParams: {
          projectId: session?.user.projectId ?? '',
        },
      },
      {
        enabled: !!session?.user.projectId,
      },
    );

  return {
    data,
    loading: isLoading,
    error,
  };
};
